import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Cookies from 'js-cookie';
import elementEnLocale from 'element-ui/lib/locale/lang/en';
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN';
import enLocale from './en';
import zhLocale from './zh';

Vue.use(VueI18n);

const i18n = new VueI18n({
locale: Cookies.get('language') || 'zh',
messages: {
en: { ...enLocale, ...elementEnLocale },
zh: { ...zhLocale, ...elementZhLocale }
}
});

export default i18n;